const Def = {
  knowledge: 'KNOWLEDGE',
  apply: 'APPLY',
};

export default Def;
